module.exports = __webpack_public_path__ + "img/jachal.me.f52ab1df.png";